module.exports = __webpack_public_path__ + "b6661b9b6974228f92606ae55ecdcc2a.jpg";